export const resources = {
    type: {
        bool: {
            label: 'Boolean',
            hint: 'Boolean'
        },
        ref: {
            label: 'Odkaz',
            hint: 'Odkaz'
        },
        enum: {
            label: 'Výčet',
            hint: 'Výčet'
        },
        int: {
            label: 'Celé číslo',
            hint: 'Celé číslo'
        },
        float: {
            label: 'Desetinné číslo',
            hint: 'Desetinné číslo'
        },
        decimal: {
            label: 'Desetinné číslo s pevnou přesností',
            hint: 'Desetinné číslo s pevnou přesností'
        },
        money: {
            label: 'Měna',
            hint: 'Měna'
        },
        string: {
            label: 'Text',
            hint: 'Text'
        },
        text: {
            label: 'Text s neomezenou délkou',
            hint: 'Text s neomezenou délkou'
        },
        richstring: {
            label: 'Text s formátováním',
            hint: 'Text s formátováním'
        },
        richtext: {
            label: 'Text s neomezenou délkou s formátováním',
            hint: 'Text s neomezenou délkou s formátováním'
        },
        local_datetime: {
            label: 'Lokální datum a čas',
            hint: 'Lokální datum a čas'
        },
        local_date: {
            label: 'Lokální datum'
        },
        local_: {
            hint: 'Lokální datum'
        },
        local_time: {
            label: 'Lokální čas',
            hint: 'Lokální čas'
        },
        utc_datetime: {
            label: 'UTC datum a čas',
            hint: 'UTC datum a čas'
        },
        zoned_datetime: {
            label: 'Datum a čas s časovou zónou',
            hint: 'Datum a čas s časovou zónou'
        },
        duration: {
            label: 'Trvání',
            hint: 'Trvání'
        }
    }
};
